import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Mail, ArrowRight } from "lucide-react";

/**
 * Sticky mobile-only "Enquire" bar — fixed to bottom of viewport on mobile.
 * Hides itself on the contact page (where the form already is).
 * Sits above the WhatsApp FAB by offsetting it accordingly.
 */
const MobileEnquireBar = () => {
    const { pathname } = useLocation();
    if (pathname === "/contact") return null;

    return (
        <Link
            to="/contact"
            data-testid="mobile-enquire-bar"
            className="lg:hidden fixed bottom-0 inset-x-0 z-40 flex items-center justify-between gap-4 px-5 py-4 bg-primary text-white border-t border-white/10 shadow-[0_-8px_24px_rgba(0,0,0,0.15)]"
        >
            <div className="flex items-center gap-3 min-w-0">
                <Mail size={18} strokeWidth={1.5} className="shrink-0 text-secondary" />
                <div className="min-w-0">
                    <div className="text-[10px] tracking-[0.2em] uppercase text-white/60 leading-none mb-1">
                        Plan Your Stay
                    </div>
                    <div className="font-display text-base leading-tight truncate">
                        Enquire about Villa Alam
                    </div>
                </div>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-secondary text-white text-[11px] tracking-[0.2em] uppercase shrink-0">
                Enquire <ArrowRight size={12} />
            </div>
        </Link>
    );
};

export default MobileEnquireBar;
